var Amplitude = {
  eventMappings: {},

  getVWOExperiments: function () {
    var vwoExperiments = {};

    try {
      var allCookies = document.cookie.split(';');

      for (var i = 0; i < allCookies.length; i++) {
        var exp = allCookies[i];
        if (exp.trim().match(/^_vis_opt_exp_[0-9]+_combi/)) {
          var expSplit = exp.split('=');
          var expName = expSplit[0].trim().replace('_vis_opt_exp', 'exp').replace('_combi', '');
          vwoExperiments[expName] = expSplit[1].trim();
        }
      }
    } catch (error) {}

    /*Currently this experiment tool functionality not used but maybe be use for future refernece.
    if (FreshChatConfig.vwoCookie && !Cookie.read("_vis_opt_exp_190_combi")) {
      Cookie.create(
        "_vis_opt_exp_190_combi",
        FreshChatConfig.vwoShow === 0 ? "1" : "2",
        100  // for 100 days
      );
      vwoExperiments['exp_190'] = FreshChatConfig.vwoShow === 0 ? "1" : "2";
    }*/

    return vwoExperiments;
  },

  getInternalABExperiments: function () {
    var internalAbExps = {};

    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key.indexOf('wp_ab_exp') > -1) { // setting this prefix for WP Internal A/B Exp framework
          var itemStr = localStorage.getItem(key),
            item = JSON.parse(itemStr);
          internalAbExps[key] = item.value;
        }
      }
    } catch (error) {}

    return internalAbExps;
  },

  init: function (key) {
    //check bsLib object length
    if (Object.keys(bsLib).length === 0) return;

    amplitude.getInstance().init(key, null, {
      includeUtm: true,
      includeReferrer: true,
      deviceId: EDS.getBsDeviceId()
    });
    AmplitudeAnalytics.user = AmplitudeAnalytics.user || {};
    AmplitudeAnalytics.user = bsLib.extend(AmplitudeAnalytics.user, {
      vwo: Amplitude.getVWOExperiments(),
    });

    //For adding user A/B exp details in amplitude
    AmplitudeAnalytics.user = bsLib.extend(AmplitudeAnalytics.user, {
      internalAbExps: Amplitude.getInternalABExperiments(),
    });

    // For adding user logging id in amplitude
    var userId = Cookie.read('bs_logging_id');
    if (userId) {
      AmplitudeAnalytics.user = bsLib.extend(AmplitudeAnalytics.user, {
        user_id: userId,
      });
    }

    // check query param for lighthouse url
    var checkLightHouseUrl = bsLib.getParameterByName('isLightHouse', document.location.href);
    if (checkLightHouseUrl === 'true') {
      AmplitudeAnalytics.user = bsLib.extend(AmplitudeAnalytics.user, {
        isLightHouse: true,
      });
    }

    Amplitude.setUserProperties(AmplitudeAnalytics.user);

    //For Debugging GA in amplitude
    if (Cookie.read('_ga')) {
      var gaClientId = Cookie.read('_ga').split('GA1.2.')[1] || '';
      if (gaClientId) {
        AmplitudeAnalytics.user = bsLib.extend(AmplitudeAnalytics.user, {
          gaClientId: gaClientId,
        });
      }
    }
  },

  logEvent: function (key, extra_data) {
    //check bsLib object length
    if (Object.keys(bsLib).length === 0) return;

    if (typeof AmplitudeAnalytics != 'undefined') {
      extra_data = typeof extra_data !== 'undefined' ? extra_data : {};
      extra_data = bsLib.extend(extra_data, {
        title: extra_data.title ? extra_data.title : document.title,
        url: document.location.href,
        referrer: document.referrer,
        referrerHostname: document.referrer.split('/')[2],
        team: 'wordpress',  // add team property for amplitude events
      });
      amplitude.getInstance().logEvent(key, extra_data);
    }
  },

  setUserIdIfPresent: function () {
    if (
      typeof AmplitudeAnalytics != 'undefined' &&
      AmplitudeAnalytics.user != undefined &&
      AmplitudeAnalytics.user.user_id != undefined
    ) {
      amplitude.getInstance().setUserId(AmplitudeAnalytics.user.user_id);
    }
  },

  setUserProperties: function (user_data) {
    if (typeof AmplitudeAnalytics != 'undefined' && typeof user_data != 'undefined') {
      amplitude.getInstance().setUserId(user_data.user_id);
      amplitude.getInstance().setUserProperties(user_data);
    }
  },
};
